import { createAction, props } from '@ngrx/store';
import { UsageSpaceRange } from '@immosky/types';

export enum UsageSpaceActions {
  Reset = '[Filter] Reset Usage Space Filter',
  Set = '[Filter] Set Usage Space Filter',
  SetBasedOnValues = '[Filter] Set Usage Space Filter Based On Values',
}

export const resetUsageSpaceFilter = createAction(UsageSpaceActions.Reset);

export const setUsageSpaceFilter = createAction(
  UsageSpaceActions.Set,
  props<{ filter: UsageSpaceRange }>()
);

export const setUsageSpaceFilterBasedOnUrlValues = createAction(
  UsageSpaceActions.SetBasedOnValues,
  props<{ values: { min: number; max: number } }>()
);
